module.exports = __webpack_public_path__ + "img/bw.5c07f943.svg";